import React from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { FormSection } from "./FormSection";
import { HCheckbox, HDatePicker, HInput } from "../../../../validation/HForm";
import { defaultMonthlyIncomeAgreements } from "../constants/constants";
import DeleteIcon from "../../../../assets/icons/trash.svg";
import PlusIcon from "../../../../assets/icons/plus-small.svg";

const defaultDealOperation = {
  monthIncomeDocs: defaultMonthlyIncomeAgreements,
};

const IncomeSection = ({ questionNumber, title }) => {
  const { control } = useFormContext();
  const isIncomeConfirmed = useWatch({ control, name: "isIncomeConfirmed" });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "monthIncomeDocs",
    keyName: "_id",
  });

  return (
    <FormSection questionNumber={questionNumber} title={title}>
      <HInput
        className="input fullwidth"
        type="text"
        name="monthlyIncome"
        autoComplete="off"
        decimals={2}
        placeholder=".руб"
      />
      
      <HCheckbox
        name="isIncomeConfirmed"
        className="input"
        label="Доход подтверждён"
      />

      {isIncomeConfirmed && (
        <>
          {fields.map((field, idx) => (
            <div key={field._id} className="d-flex columns-2">
              <div className="flex-1">
                <label className="form-element-label">Номер документа</label>
                <HInput
                  className="input fullwidth"
                  type="text"
                  name={`monthIncomeDocs.${idx}.incomeDocNumber`}
                  defaultValue={field.incomeDocNumber}
                />
              </div>
              
              <div className="flex-1">
                <label className="form-element-label">Дата документа</label>
                <HDatePicker
                  h="true"
                  className="input fullwidth"
                  name={`monthIncomeDocs.${idx}.incomeDocDate`}
                  defaultValue={field.incomeDocDate}
                />
              </div>

              <div className="flex-1">
                <label className="form-element-label">Сумма (руб.)</label>
                <HInput
                  className="input fullwidth"
                  name={`monthIncomeDocs.${idx}.monthlyIncome`}
                  decimals={2}
                  defaultValue={field.monthlyIncome}
                />
              </div>
              
              {fields.length > 1 && (
                <button
                  type="button"
                  className="button-icontrigger flex-align-self-end"
                  onClick={() => remove(idx)}
                >
                  <span className="icon">
                    <DeleteIcon />
                  </span>
                </button>
              )}
            </div>
          ))}
          
          <div className="text-right">
            <button
              className="action-item"
              type="button"
              onClick={() => append(defaultDealOperation)}
            >
              <span className="icon m-r-spacer">
                <PlusIcon />
              </span>
              <span>Добавить</span>
            </button>
          </div>
        </>
      )}
    </FormSection>
  );
};

export default IncomeSection;
